import React from "react";
import { FormControl } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";

export default class ReportsParameterStatus extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            statusList: []
        };

        this.getStatusList = this.getStatusList.bind(this);
        this.getStatusList();
    }    

    handleChange() {
        if (this.props.onChange)
            this.props.onChange(this.inputEl.value);
    }

    getStatusList() {
        let self = this;
        let vm = self.state;
        ajax.api().get("get-report-parameter-statuses")
            .then(function (res) {
                self.setState({ statusList: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    render() {
        var statusListToRender = [];
        statusListToRender.push(<option key="All" value="">All</option>);

        this.state.statusList.map(function (item, i) {
            statusListToRender.push(<option key={item.statusCode} value={item.statusCode}>{item.statusCode}</option>)
        }, this);

        return (        
            <div className="ap-report-control-dropdown">
                <FormControl
                    componentClass="select"
                    placeholder="select"
                    onChange={this.handleChange.bind(this)}
                    inputRef={el => this.inputEl = el}>
                    {statusListToRender}
                </FormControl>
            </div>
        );
    }
}